import { isUndefinedOrEmpty } from '$tablet-app/src/app/utils/strings';
import { AppRecord } from '../types';

interface Params {
  label?: string;
  apps: AppRecord[];
}

const findAppByLabel = ({ label, apps }: Params): AppRecord | undefined => {
  if (isUndefinedOrEmpty(label)) return;

  const lowercase_label = (label as string).toLowerCase();

  return apps.find((app) => app.label.toLowerCase().includes(lowercase_label));
};

export default findAppByLabel;
